import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import IMG1 from "../../../images/industries/retail/Retail-Analytics.webp";
import IMG2 from "../../../images/industries/retail/All-Inclusive-Sales-Management.webp";
import IMG3 from "../../../images/industries/retail/Mobile-Access.webp";
import IMG4 from "../../../images/industries/retail/Payment-Integration.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Demandfeatures(props) {
    const [toggleState, setToggleState] = useState(0);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";
    return (
        <section className="tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Retail Software">
                            <h2>Hassle-Free Retail Software Solutions For Unparalleled User Experience</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol offers state-of-the-art retail management software to simplify all your retail
                            operations. Our retail management software has made things easier for B2B and B2C
                            consumer-based retail businesses and enterprises with advanced built-in features like a
                            point of sale, dashboard analytics, contactless payments, inventory management, and
                            more. </p>
                    </Col>
                </Row>
                <Row>

                    <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
                        <div className={`industries_boxes hover01 ${getActiveClass(0, "active-tabs")}`}
                             onClick={() => toggleTab(0)}>
                            <LazyLoadImage
                                src={IMG1}
                                effect="blur" alt="IMG1" className="img-fluid"
                            />
                            <h6>Retail Analytics</h6>
                        </div>
                    </Col>
                    <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
                        <div className={`industries_boxes hover01 ${getActiveClass(1, "active-tabs")}`}
                             onClick={() => toggleTab(1)}>
                            <LazyLoadImage
                                src={IMG2}
                                effect="blur" alt="IMG2" className="img-fluid"
                            />
                            <h6>Sales Management</h6>
                        </div>
                    </Col>
                    <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
                        <div className={`industries_boxes hover01 ${getActiveClass(2, "active-tabs")}`}
                             onClick={() => toggleTab(2)}>
                            <LazyLoadImage
                                src={IMG3}
                                effect="blur" alt="IMG3" className="img-fluid"
                            />
                            <h6>Mobile Access</h6>
                        </div>
                    </Col>
                    <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
                        <div className={`industries_boxes hover01 ${getActiveClass(3, "active-tabs")}`}
                             onClick={() => toggleTab(3)}>
                            <LazyLoadImage
                                src={IMG4}
                                effect="blur" alt="IMG4" className="img-fluid"
                            />
                            <h6>Payment Integration</h6>
                        </div>
                    </Col>

                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <p className={toggleState === 0 ? 'industries_content d-block' : "content d-none"}
                        >Our retail software solutions help retail business owners improve their decision-making
                            capabilities by providing detailed insights on products and customers. The retail analytics
                            feature helps businesses enhance operational efficiencies and maximize revenue.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <p className={toggleState === 1 ? 'industries_content d-block' : "content d-none"}
                        >Our retail software solutions enable business owners to streamline all their sales channels and
                            improve user experience significantly. The all-inclusive retail sales management feature in
                            our retail software helps retailers diversify their salesforce, improve coordination between
                            internal sales teams, simplify purchasing, and deliver an exceptional user experience.
                        </p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <p className={toggleState === 2 ? 'industries_content d-block' : "content d-none"}
                        >Retail software solutions we create at TekRevol are developed using state-of-the-art
                            development techniques and modern technology frameworks that facilitate retail business
                            owners to run their operations on any device anywhere. Our retail software supports
                            integration with multiple devices, such as laptops, desktops, smartphones, and tablets.
                        </p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <p className={toggleState === 3 ? 'industries_content d-block' : "content d-none"}
                        >Our retail software solutions enable businesses to make payment collection smooth and
                            hassle-free. Our retail software supports contactless payments and facilitiates end users to
                            pay with their preferred payment option from debit card, credit card, digital wallets, and
                            more. We make sure our retail software is tailor-made and fulfills all the requirements of
                            vendors and end users.
                        </p>
                    </Col>

                </Row>
            </Container>
        </section>
    );
}

export default Demandfeatures;